import { Box, Flex, Heading, Icon, Text } from "@chakra-ui/react";
import React from "react";
import { FiShield } from "react-icons/fi";
import { CyberIdButton } from "../../../components/CyberIdButton";

interface CyberidVerifyGateProps {
  minAssuranceLevel: number;
  onVerify: () => void;
  isLoading?: boolean;
}

/** Bramka: to głosowanie wymaga zweryfikowanej tożsamości przez CyberID (per głosowanie, BEZ zakładania konta). */
export const CyberidVerifyGate: React.FC<CyberidVerifyGateProps> = ({ minAssuranceLevel, onVerify, isLoading }) => (
  <Box bg="white" borderRadius="18px" border="1px solid rgba(67,0,152,0.10)" p={{ base: "22px 18px", md: "28px 26px" }}>
    <Flex direction="column" align="center" textAlign="center">
      <Flex w="56px" h="56px" borderRadius="full" bg="rgba(67,0,152,0.08)" align="center" justify="center" mb="14px">
        <Icon as={FiShield} boxSize="26px" color="primary" />
      </Flex>
      <Heading fontSize="19px" color="primary" fontWeight="800" mb="8px">
        To głosowanie wymaga zweryfikowanej tożsamości
      </Heading>
      <Text fontSize="14px" color="gray.500" mb="20px" lineHeight="1.6">
        Potwierdź tożsamość przez CyberID (poziom A{minAssuranceLevel}), aby oddać głos. Nie zakładasz konta — weryfikacja jest jednorazowa dla tego głosowania.
      </Text>
      <Box w="100%" maxW="320px">
        <CyberIdButton onClick={onVerify} isLoading={isLoading} />
      </Box>
    </Flex>
  </Box>
);
